module.exports = __webpack_public_path__ + "img/PX Mart.572f1788.svg";